import { Campaign, Lead, Post, Product } from '../types/marketing';
import { 
  getProducts as getProductsFromMock,
  getLeads,
  createLead,
  updateLead,
  deleteLead,
  getLeadStats,
  getProductStats,
  getCampaigns as getCampaignsFromMock,
  createCampaign as createCampaignFromMock,
  updateCampaign as updateCampaignFromMock,
  deleteCampaign as deleteCampaignFromMock,
  sendCampaign as sendCampaignFromMock,
  getCampaignMetrics as getCampaignMetricsFromMock
} from './mockData';

// Simulação de API
const API_URL = 'http://localhost:5000/api';

export type { Product };

export const marketingService = {
  // Campanhas
  async getCampaigns(): Promise<Campaign[]> {
    try {
      const campaigns = await getCampaignsFromMock();
      console.log('marketingService.getCampaigns: Retornando campanhas:', campaigns);
      return campaigns;
    } catch (error) {
      console.error('Erro ao buscar campanhas:', error);
      throw new Error('Erro ao buscar campanhas');
    }
  },

  async createCampaign(formData: FormData): Promise<Campaign> {
    try {
      console.log('marketingService.createCampaign: Status recebido:', formData.get('status'));
      const campaign = await createCampaignFromMock(formData);
      console.log('marketingService.createCampaign: Campanha criada com status:', campaign.status);
      return campaign;
    } catch (error) {
      console.error('Erro ao criar campanha:', error);
      throw new Error('Erro ao criar campanha');
    }
  },

  async updateCampaign(id: string, campaign: Partial<Campaign>): Promise<Campaign> {
    try {
      return await updateCampaignFromMock(id, campaign);
    } catch (error) {
      console.error('Erro ao atualizar campanha:', error);
      throw new Error('Erro ao atualizar campanha');
    }
  },

  async deleteCampaign(id: string): Promise<void> {
    try {
      await deleteCampaignFromMock(id);
    } catch (error) {
      console.error('Erro ao excluir campanha:', error);
      throw new Error('Erro ao excluir campanha');
    }
  },

  async sendCampaign(id: string): Promise<void> {
    try {
      await sendCampaignFromMock(id);
    } catch (error) {
      console.error('Erro ao enviar campanha:', error);
      throw new Error('Erro ao enviar campanha');
    }
  },

  async getCampaignMetrics(id: string): Promise<{
    sentCount: number;
    openCount: number;
    clickCount: number;
  }> {
    try {
      return await getCampaignMetricsFromMock(id);
    } catch (error) {
      console.error('Erro ao buscar métricas da campanha:', error);
      throw new Error('Erro ao buscar métricas da campanha');
    }
  },

  // Leads
  getLeads,
  createLead,
  updateLead,
  deleteLead,
  getLeadStats,

  // Produtos
  async getProducts(): Promise<Product[]> {
    const products = await getProductsFromMock();
    return products.map((product) => ({
      id: product.id,
      code: product.code,
      type: product.type,
      name: product.name,
      description: product.description,
      price: product.price,
      imageUrl: product.imageUrl,
      category: product.category,
      videoUrl: product.videoUrl
    }));
  },

  async searchProducts(query: string): Promise<Array<{ id: string; name: string; price: number }>> {
    const products = await getProductsFromMock();
    const filteredProducts = products.filter((product: Product) => 
      product.name.toLowerCase().includes(query.toLowerCase()) ||
      product.description.toLowerCase().includes(query.toLowerCase())
    );
    return filteredProducts.map((product: Product) => ({
      id: product.id,
      name: product.name,
      price: product.price
    }));
  },

  improveTextWithAI: async (text: string): Promise<{ improvedText: string }> => {
    const response = await fetch(`${API_URL}/ai/improve-text`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ text }),
    });

    if (!response.ok) {
      throw new Error('Erro ao melhorar texto com IA');
    }

    return response.json();
  },

  createPost: async (formData: FormData): Promise<Post> => {
    const response = await fetch('http://localhost:3001/api/marketing/posts', {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error('Erro ao criar post');
    }

    return response.json();
  },
}; 